import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import { ColorClassSuffix } from 'features/shared/enums/colorClassSuffix';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  route: string; 
  colorSuffix?: ColorClassSuffix;
  isOutline?: boolean;
  className?: string;
  isExternalLink?: boolean;
}

const ResultDialogButton = ({ title, route, colorSuffix = "primary", isOutline, className, isExternalLink }: Props) => {
  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // helpers
  const getButtonClassName = () => {
    return `btn btn${isOutline ? "-outline" : ""}-${colorSuffix}${className ? ` ${className}` : ""}`;
  };

  // render
  if (isExternalLink) {
    return (
      <a
        className={getButtonClassName()}
        href={route}
      >
        {title}
      </a>
    );
  } else {
    return (
      <Link
        className={getButtonClassName()}
        to={route}
        onClick={() => dialogService.closeDialog()}
      >
        {title}
      </Link>
    )
  }
}

export default ResultDialogButton;
